import * as types from './mutations-types'

const actions = {
  [types.UPDATELOADINGSTATUS] ({ commit }, payload) {
    commit(types.UPDATELOADINGSTATUS, payload)
  },
  [types.UPDATEDIRECTION] ({ commit }, payload) {
    commit(types.UPDATEDIRECTION, payload)
  },
  [types.UPDATEUSER] ({ commit }, payload) {
    commit(types.UPDATEUSER, payload)
  },
  [types.UPDATETITLE] ({ commit }, payload) {
    commit(types.UPDATETITLE, payload)
  },
  [types.UPDATECLIENT] ({ commit }, payload) {
    commit(types.UPDATECLIENT, payload)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js